import { PersonType } from 'models'
import {
  FC,
  createContext,
  useContext,
  useState,
  useEffect,
  PropsWithChildren,
} from 'react'
import { AnimatePresence } from 'framer-motion'

import { config } from 'config'
import { Loader } from 'components/loader'

type DataContextType = {
  people: PersonType[]
  setPeople: (people: PersonType[]) => void
  appLocale: typeof config.locale
  texts: Partial<{ [k in keyof PersonType]: string }>
  translate: (key: string) => string
  locale: Array<{
    ENGLISH: string
    KYRGYZ: string
  }>
}

const DataContext = createContext<DataContextType | null>(null)

export const DataProvider: FC<PropsWithChildren> = ({ children }) => {
  const params = new URLSearchParams(window.location.search)
  const appLocale = (params.get('lang') ||
    config.locale) as typeof config.locale
  const [texts, setTexts] = useState<DataContextType['texts']>({})
  const [locale, setLocale] = useState<DataContextType['locale']>([])
  const [people, setPeople] = useState<PersonType[]>([])

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data.json`)
      .then((res) => res.json())
      .then((res) => {
        setPeople(res.data)
        setTexts(res.translations)
        setLocale(res.texts)
      })
      .catch((err) => {
        console.log('error', err)
      })
  }, [])

  return (
    <DataContext.Provider
      value={{
        people,
        setPeople,
        appLocale,
        texts,
        locale,
        translate: (key: string) =>
          locale.find((row) => row.ENGLISH === key)?.KYRGYZ ?? key,
      }}
    >
      <AnimatePresence mode="wait">
        {!people.length && <Loader />}
      </AnimatePresence>
      {people.length > 0 && children}
    </DataContext.Provider>
  )
}

export const useDataContext = () => {
  const context = useContext(DataContext)
  return context as DataContextType
}
